import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { entityMergers } from './mergeStrategies';
import { reduxKey } from './constants';
const defaultState = {};
export const reducer = (state = defaultState, action)=>{
    const freshEntities = action.entities || action.payload && action.payload.entities || action.meta && action.meta.entities;
    if (freshEntities) {
        const updatedState = _object_spread({}, state);
        Object.keys(freshEntities).forEach((entityType)=>{
            // update obj reference only for those entity groups
            // that arrived in the action
            updatedState[entityType] = _object_spread({}, state[entityType]);
            Object.keys(freshEntities[entityType]).forEach((entityId)=>{
                const existing = updatedState[entityType][entityId];
                const incoming = freshEntities[entityType][entityId];
                const merge = entityMergers[entityType];
                // if there is no already existing item,
                // or we don't have a special merge strategy,
                // just overwrite straight away
                if (!existing || !merge) {
                    updatedState[entityType][entityId] = incoming;
                    return;
                }
                // otherwise merge the two entities
                updatedState[entityType][entityId] = merge(existing, incoming);
            });
        });
        return updatedState;
    }
    return state;
};
const reducers = {
    [reduxKey]: reducer
};
export default reducers;
